"use client";

// packages/eden-table/src/components/TR.jsx
import { useContext } from "react";
import {
  highlightRed,
  highlightOrange,
  highlightYellow,
  highlightGreen,
  highlightBlue,
  highlightDarkBlue,
  highlightPurple,
  highlightPink,
  highlightBrown,
  highlightGrey
} from "@churchofjesuschrist/eden-style-constants";
import RowSelectionContext from './RowSelection/Context.js';
import TableSectionContext from './Table/TableSectionContext.js';
import TD from './TD.js';
import { TableContext } from './Table/Table.js';
import { jsx, jsxs } from "react/jsx-runtime";
var highlights = {
  red: highlightRed,
  orange: highlightOrange,
  yellow: highlightYellow,
  green: highlightGreen,
  blue: highlightBlue,
  darkblue: highlightDarkBlue,
  purple: highlightPurple,
  pink: highlightPink,
  brown: highlightBrown,
  grey: highlightGrey
};
var TR = ({
  children,
  highlighted,
  highlightColor = "darkblue",
  id,
  noSelection,
  ...props
}) => {
  const tableSection = useContext(TableSectionContext);
  const rowSelection = useContext(RowSelectionContext);
  const renderRowChildren = useContext(TableContext);
  const isHighlighted = highlighted || rowSelection?.selected?.includes(id);
  const backgroundColor = isHighlighted ? highlights[highlightColor] : void 0;
  return /* @__PURE__ */ jsxs("tr", { ...props, id, role: "row", style: { backgroundColor }, children: [
    rowSelection ? tableSection === "thead" && !noSelection ? /* @__PURE__ */ jsx(rowSelection.SelectAllCell, {}) : tableSection === "tbody" && !noSelection ? /* @__PURE__ */ jsx(rowSelection.SelectRowCell, { id }) : /* @__PURE__ */ jsx(TD, {}) : null,
    renderRowChildren(children)
  ] });
};
TR.displayName = "TR";
var TR_default = TR;
export {
  TR_default as default
};
